import React from 'react';
import { trustedCompanies } from '../data/jobsData';

const TrustedCompanies = () => {
  return (
    <section className="trust sec-space obj-width">
      <h2>Partnership with trusted organizations</h2>
    

      <div className="t-box">
        {trustedCompanies.map((company) => (
          <img
            key={company.id}
            src={company.image}
            alt={`Company ${company.id}`}
          />
        ))}
      </div>
    </section>
  );
};

export default TrustedCompanies;
